import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

const stages = [
  {
    tag: "发生",
    title: "事情刚出现",
    desc: "记录最早可核对的时间点和公开信息出处，先把起点钉住，避免后面越传越远。",
    icon: "ri-flashlight-line",
  },
  {
    tag: "发酵",
    title: "讨论开始扩散",
    desc: "整理讨论焦点往哪个方向走，是规则问题、事实问题，还是单纯的情绪对立。",
    icon: "ri-bubble-chart-line",
  },
  {
    tag: "回应",
    title: "当事方给出说法",
    desc: "把各方回应的原文要点列出来，标注回应是否回答了核心疑问。",
    icon: "ri-chat-check-line",
  },
  {
    tag: "后续",
    title: "收尾与新变化",
    desc: "补充处理结果、补充说明和新的进展，让整条事件串有始有终。",
    icon: "ri-flag-2-line",
  },
];

export default function TrackFlow() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="HOW WE TRACK"
              title="一条瓜是怎么被整理成事件串的"
              desc="我们不写碎片式的「听说」，而是把同一件事按四个固定段落排好，这样你从上往下读一遍，就能自己判断事情的走向。"
            />
            <Link
              to="/events"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-book-open-line" />
              拿一条真实事件串看看
            </Link>
          </div>

          <div className="lg:col-span-7">
            <ol className="relative flex flex-col gap-4 border-l-2 border-dashed border-background-300 pl-6">
              {stages.map((stage, index) => (
                <Reveal key={stage.tag} delay={index * 80}>
                  <li className="relative rounded-lg border border-background-200 bg-background-50 p-5">
                    <span className="absolute -left-[35px] top-5 flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-background-50">
                      <i className={`${stage.icon} text-sm`} />
                    </span>
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-semibold text-primary-800">
                        {stage.tag}
                      </span>
                      <h3 className="font-heading text-base font-bold text-foreground-950">{stage.title}</h3>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{stage.desc}</p>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}